// Same-origin in production; override locally with REACT_APP_API_URL if needed.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
